import styled from "styled-components";

export const AssistantIframe = styled.iframe`
  ${({ $isVisible, $positionTop, $positionLeft }) => {
    if ($isVisible) {
      return `
        z-index: 100;
        top: ${$positionTop};
        left: ${$positionLeft};
        position: fixed;
      `;
    } else {
      return `
        position: absolute;
        left: -999em;
      `;
    }
  }};
  background-color: ${({ theme }) => theme.colors.white};
  height: ${({ $height }) => $height}px;
  width: ${({ $mobileWidth }) => $mobileWidth};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: ${({ $tabletWidth }) => $tabletWidth};
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: ${({ $desktopWidth }) => $desktopWidth};
  }
`;
